import styled from "styled-components";
import FlexBox from "./FlexBox";
import { StyledText, TextSize, TextStatus } from "./Text";
import Icon from "./Icon";
import { getNoCurriculumVersionMessage } from "../utils/exploreCompetency";
import theme from "../styles/theme";

const EmptyStateCard = styled(FlexBox)`
  position: fixed;
  top: 74px;
  left: ${theme.sidebarWidth};
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
  z-index: 1;
`;

const EmptyStateInner = styled(FlexBox)`
  max-width: 480px;
  text-align: center;
  padding: 28px 32px;
  background: #191b34;
  border-radius: 8px;
  border: 1px solid #3c406c;
  transform: translateY(-48px);
`;

type Props = {
  programLabel?: string;
  semesterLabel?: string;
};

const ExploreNoVersionState = ({ programLabel, semesterLabel }: Props) => (
  <EmptyStateCard direction="column">
    <EmptyStateInner direction="column" space={3}>
      <Icon name="info-circle" color="#a0a4c4" fixedWidth={false} />
      <StyledText fontWeight="700" textSize={TextSize.default}>
        No curriculum version available
      </StyledText>
      <StyledText status={TextStatus.muted} textSize={TextSize.default}>
        {getNoCurriculumVersionMessage(programLabel, semesterLabel)}
      </StyledText>
    </EmptyStateInner>
  </EmptyStateCard>
);

export default ExploreNoVersionState;
